import { useState } from 'react';
import { faqs } from '@/mocks/data';

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIdx(openIdx === idx ? null : idx);
  };

  return (
    <section className="w-full px-4 md:px-6 py-14">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
          常见问题
        </h2>
        <p className="mt-2 text-sm text-foreground-500">快速了解cy社区</p>
      </div>
      <div className="max-w-3xl mx-auto space-y-3">
        {faqs.map((faq, idx) => (
          <div
            key={idx}
            className="rounded-lg border border-background-200/70 bg-background-50 overflow-hidden"
          >
            <button
              onClick={() => toggle(idx)}
              className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-50/80 transition-colors"
            >
              <span className="text-sm font-medium text-foreground-800 pr-4">{faq.question}</span>
              <span className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openIdx === idx ? 'rotate-45' : ''}`}>
                <i className="ri-add-line text-foreground-400"></i>
              </span>
            </button>
            <div
              className={`overflow-hidden transition-all duration-300 ${
                openIdx === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
              }`}
            >
              <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                {faq.answer}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}